import { Box, Button } from '@mui/material';

export const ToastifyCloseButton = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '2rem' }}>
      <Button sx={{ backgroundColor: 'transparent', color: 'white', padding: 0 }}>✖</Button>
    </Box>
  );
};
